<template>
    <customModal
        v-if="documentApprovalModal == true"
        :containermd="true"
        :footerShow="true"
        @closeModal="closeDocumentApprovalModal()"
    >
        <template #title> Assign Approvers</template>
        <template #body>
            <div class="row mb-2">
                <div class="col-6">
                    <label class="">{{ $t("navigations.choose role") }}</label>
                    <Multiselect
                        mode="multiple"
                        :searchable="true"
                        trackBy="role_Name"
                        valueProp="id"
                        placeholder="Select"
                        label="role_Name"
                        :options="roleList"
                        :hideSelected="false"
                        :closeOnSelect="false"
                        class="multiselect-template-theme mr-0 mt-1"
                        @change="onChange"
                    />
                </div>
                <div class="col-6">
                    <label class="">{{ $t("navigations.due date") }}</label>
                    <input type="date" class="form-control" />
                </div>
            </div>
            <h4>Users</h4>
            <div class="height-scroll">
                <table class="table fixed-header">
                    <thead>
                        <tr>
                        <th>
                            <input
                                class="mr-1"
                                type="checkbox"
                                id="selectAllDocumentApprovers"
                                @change="selectall()"
                            />
                            Users
                        </th>
                        <th></th>
                        <th class="text-center">Save</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </template>
  </customModal>
</template>
<script src="./AssignRuleApprover.js"></script>
<style scoped>
</style>